import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";

/** 旧 subAccountPermissionDialog.vue 的 React 对应物。 */
export function SubAccountPermissionDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
    const navigate = useNavigate();
    return <Modal className="sub-account-permission-dialog" width={520} title={null} open={open} footer={<Button type="primary" onClick={() => navigate("/me/member")}>去开通</Button>} onCancel={onClose}><div className="sub-account-permission-content"><i className="iconfont icon-Frame" /><div>开通或升级链云会员 继续使用子账号</div></div></Modal>;
}
